import { useNavigate } from "react-router-dom";
import LargeItemCard from "./base/LargeItemCard.jsx";

export default function AddRace({event_id}) {

    const navigate = useNavigate();
    const handleItemClick = () => {
        navigate(`/events/${event_id}/create-race`);
    };

   return (
    <LargeItemCard onClick={handleItemClick} justify={true}>          
      <div style={styles.cardContent}>
        <h3 style={styles.title}>Ajouter une course</h3>
        <p style={styles.subtitle}>Créer une nouvelle course</p>
      </div>
      <span style={styles.plus}>+</span>
    </LargeItemCard>
  );
}

const styles = {
  plus: {
    fontSize: "56px",
    lineHeight: 1,
    color: "#9aa0a6",
    fontWeight: 600,
  },
  cardContent: {
    textAlign: "center",
  },
  title: {
    fontSize: "18px",
    fontWeight: 600,
    color: "#4e5457",
    margin: "0 0 6px 0",
  },
  subtitle: {
    fontSize: "13px",
    color: "#8a8f93",
    margin: 0,
  },
};